/**
 * 포인트 요약 카드 컴포넌트
 */
import { useLanguage } from '@/contexts/AppContext';
import { getPointsTranslations } from './constants';
import type { PointsData } from './types';

interface PointsSummaryCardProps {
  pointsData: PointsData;
}

export function PointsSummaryCard({ pointsData }: PointsSummaryCardProps) {
  const { locale } = useLanguage();
  const t = getPointsTranslations(locale);
  const { totalPoints, pointsEarned, pointsUsed, pointsExpiring } = pointsData;

  return (
    <div className="bg-background rounded-[10px] p-4 mb-3">
      {/* Points Display */}
      <div className="text-center mb-3">
        <p className="text-[24px] font-bold text-primary leading-none">
          {totalPoints.toLocaleString(locale)}<span className="text-[14px] ml-1">P</span>
        </p>
      </div>

      {/* Quick Stats */}
      <div className="flex items-center justify-between px-2 gap-4">
        {/* Points Earned */}
        <div className="flex-1 text-center">
          <p className="text-[10px] text-muted-foreground mb-1">
            {t.pointsEarned}
          </p>
          <p className="text-[13px] font-bold text-primary">
            {pointsEarned.toLocaleString(locale)}
          </p>
        </div>

        <div className="w-[1px] h-8 bg-border" />

        {/* Points Used */}
        <div className="flex-1 text-center">
          <p className="text-[10px] text-muted-foreground mb-1">
            {t.pointsUsed}
          </p>
          <p className="text-[13px] font-bold text-foreground">
            {pointsUsed.toLocaleString(locale)}
          </p>
        </div>

        <div className="w-[1px] h-8 bg-border" />

        {/* Points Expiring */}
        <div className="flex-1 text-center">
          <p className="text-[10px] text-muted-foreground mb-1">
            {t.pointsExpiring}
          </p>
          <p className="text-[13px] font-bold text-warning">
            {pointsExpiring.toLocaleString(locale)}
          </p>
        </div>
      </div>
    </div>
  );
}
